var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade-out"}},[_c('div',{class:['loading-component-container', { inline: _vm.inline }]},[_c('div',{staticClass:"center"},[_c('loading-bar')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }